import axios, { AxiosResponse } from 'axios';

export const GET_USER_ROUTE = `/user`;
export const GET_USER_PROFILE = `/user/profile`;
export const GET_VENDORS = `/user/vendors`;

export const getUser = (id: string): Promise<AxiosResponse<any>> => {
    return axios.get(`${GET_USER_ROUTE}/${id}`);
};

export const getUserProfile = (): Promise<AxiosResponse<any>> => {
    return axios.get(GET_USER_PROFILE);
};

export const getVendors = (): Promise<AxiosResponse<any>> => {
    return axios.get(`${GET_VENDORS}`);
};
